import React, { useState, useEffect, useRef } from "react";

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";
import { averageString } from "./globalVariables";
import { formatCurrency, parseOOPercent } from "./pureFunctions";
import { useConfig } from "./ConfigContext";

export default function NutzergrafikObjektverlauf({
   users,
   auftragsDatumEstates,
   // verkaufsDatumEstates,
   setSelectedUser,
   year,
}) {
   const config = useConfig();
   const [graphData, setGraphData] = useState();
   const [totalData, setTotalData] = useState();

   useEffect(() => {
      let userdata = {};
      let userdataVerkaufsdat = {};

      if (auftragsDatumEstates && /* verkaufsDatumEstates &&  */users) {
         /* verkaufsDatumEstates.forEach((item) => {
            let itemuser = item.elements.benutzer;

            if (!userdataVerkaufsdat[itemuser]) {
               userdataVerkaufsdat[itemuser] = Object.keys(config.stats.vk.stufen).reduce(
                  (oldObj, item) => ({ ...oldObj, [item]: [] }),
                  {},
               );
            }
            userdataVerkaufsdat[itemuser][item.elements.status2].push(item);
         });
         console.log(userdataVerkaufsdat); */

         auftragsDatumEstates.forEach((item) => {
            let itemuser = item.elements.benutzer;

            if (!userdata[itemuser]) {
               userdata[itemuser] = Object.keys(config.stats.vk.stufen).reduce(
                  (oldObj, item) => ({ ...oldObj, [item]: [] }),
                  {},
               );
            }
            userdata[itemuser][item.elements.status2].push(item);
         });

         let userGraphData = Object.keys(userdata).map((item) => {
            return {
               ["name"]: users[item] ? users[item].Kuerzel : item,
               // ["Alle Verkauft"]: userdataVerkaufsdat[item] ? userdataVerkaufsdat[item].verkauft.length : 0,
               ["data"]: userdata[item],
               ["userId"]: item,
               ...Object.keys(config.stats.vk.stufen).reduce(
                  (oldObj, stufenItem) => ({
                     ...oldObj,
                     [config.stats.vk.stufen[stufenItem]]: userdata[item][stufenItem].length,
                  }),
                  {},
               ),
            };
         });

         console.log(userGraphData);

         let totalGraphData = {
            // ["In Bewertung"]: auftragsDatumEstates.filter((estItem) => estItem.elements.status2 === "in_akquise"),
            ["In Vorlauf (offline)"]: auftragsDatumEstates.filter(
               (estItem) => estItem.elements.status2 === "ind_Schl_5021",
            ),
            ["In Vorlauf (online)"]: auftragsDatumEstates.filter(
               (estItem) => estItem.elements.status2 === "ind_Schl_2927",
            ),
            ["Aktiv im Verkauf"]: auftragsDatumEstates.filter(
               (estItem) => estItem.elements.status2 === "status2obj_aktiv",
            ),
            ["In Abwicklung"]: auftragsDatumEstates.filter((estItem) => estItem.elements.status2 === "ind_Schl_2929"),
            ["Fremd verkauft"]: auftragsDatumEstates.filter(
               (estItem) => estItem.elements.status2 === "fremd_verkauft_vermietet",
            ),
            ["Auftrag entzogen"]: auftragsDatumEstates.filter(
               (estItem) => estItem.elements.status2 === "auftrag_entzogen",
            ),
            ["Verkauft"]: auftragsDatumEstates.filter((estItem) => estItem.elements.status2 === "verkauft"),

            // ["Alle Verkauft"]: verkaufsDatumEstates.filter((estItem) => estItem.elements.status2 === "verkauft"),
         };

         let avgGraphData = {
            ["name"]: "⌀",
            // ["In Bewertung"]: totalGraphData["In Bewertung"].length / userGraphData.length,
            ["In Vorlauf (offline)"]: totalGraphData["In Vorlauf (offline)"].length / userGraphData.length,
            ["In Vorlauf (online)"]: totalGraphData["In Vorlauf (online)"].length / userGraphData.length,
            ["Aktiv im Verkauf"]: totalGraphData["Aktiv im Verkauf"].length / userGraphData.length,
            ["In Abwicklung"]: totalGraphData["In Abwicklung"].length / userGraphData.length,
            ["Fremd verkauft"]: totalGraphData["Fremd verkauft"].length / userGraphData.length,
            ["Auftrag entzogen"]: totalGraphData["Auftrag entzogen"].length / userGraphData.length,
            ["Verkauft"]: totalGraphData["Verkauft"].length / userGraphData.length,

            // ["Alle Verkauft"]: totalGraphData["Alle Verkauft"].length / userGraphData.length,
            ["data"]: {},
            ["userId"]: "⌀",
         };

         setTotalData(totalGraphData);

         setGraphData([...userGraphData, avgGraphData]);
      }
   }, [auftragsDatumEstates, /* verkaufsDatumEstates, */ users]);

   function renderCustomBarLabel({ e, x, y, width, height, value, altLabel, sumLabel }) {
      return (
         // <text x={x + width / 2} y={y} fill="#eef" fontWeight={500} textAnchor="middle" dy={-7}>
         <text
            style={{ zIndex: 10 }}
            x={x + width / 2}
            y={sumLabel ? y - 10 : y + height / 2 + 5}
            fill={sumLabel ? "#eef" : "#000"}
            fontWeight={500}
            fontSize={sumLabel ? 20 : 14}
            textAnchor="middle"
            dy={0}
         >
            <tspan textAnchor="middle">{value ? Math.round(value * 10) / 10 : ""}</tspan>
            {altLabel && (
               <tspan style={{ fontSize: 16 }} textAnchor="middle" /* x={x + width / 2} y={y - 28} */>
                  {" "}
                  {altLabel}
               </tspan>
            )}
         </text>
      );
   }

   function CustomTooltip({ active, payload, label }) {
      const isVisible = active && payload && payload.length;
      let successRate;
      let successRateZukunft;

      let counter = 0;
      let totalProvision = 0;
      let totalkaufpreis = 0;
      let errorObjekt = [];
      if (isVisible) {
         // console.log(payload);
         let currentPayload = payload[0].payload;
         // console.log(currentPayload);
         Object.keys(currentPayload.data).forEach((status2key) => {
            if (!(status2key === "auftrag_entzogen" || status2key === "fremd_verkauft_vermietet")) {
               currentPayload.data[status2key].forEach((estItem) => {
                  counter++;
                  let kp = estItem.elements[config.estate.verkauftFur]
                     ? parseFloat(estItem.elements[config.estate.verkauftFur])
                     : parseFloat(
                          estItem.elements[config.estate.kaufpreis] ? estItem.elements[config.estate.kaufpreis] : 0,
                       );
                  totalkaufpreis += kp;

                  let prov =
                     (estItem.elements[config.estate.provPausAK] !== "0.00"
                        ? parseFloat(estItem.elements[config.estate.provPausAK])
                        : parseOOPercent(estItem.elements[config.estate.provAussen]) * kp) +
                     (estItem.elements[config.estate.provPausVK] !== "0.00"
                        ? parseFloat(estItem.elements[config.estate.provPausVK])
                        : parseOOPercent(estItem.elements[config.estate.provInnen]) * kp);
                  totalProvision += isNaN(prov) ? 0 : prov;
                  if (isNaN(prov)) {
                     // console.log(estItem.elements);
                     errorObjekt.push(estItem.elements.objektnr_extern);
                  }
               });
            }
         });
         let verloren = currentPayload["Auftrag entzogen"] + currentPayload["Fremd verkauft"];
         let verkauft = currentPayload["Verkauft"];

         let verkauftZukunft =
            currentPayload["Verkauft"] +
            currentPayload["In Abwicklung"] +
            currentPayload["Aktiv im Verkauf"] +
            currentPayload["In Vorlauf (online)"] +
            currentPayload["In Vorlauf (offline)"];

         successRate = (100 * verkauft) / (verloren + verkauft);
         successRateZukunft = (100 * verkauftZukunft) / (verloren + verkauftZukunft);
      }

      return (
         <div
            style={{
               visibility: isVisible ? "visible" : "hidden",
               backgroundColor: "#fffe",
               borderRadius: "10px",
               color: "#000",
               padding: "10px",
               margin: "0 40px",
               boxShadow: "0 0 20px 2px #000",
               position: "relative",
            }}
         >
            {isVisible && (
               <div>
                  <p className="label">
                     {users[payload[0].payload.userId]
                        ? users[payload[0].payload.userId].Name
                        : payload[0].payload.userId}

                     <span className="ms-2">aktuelle Erfolgsquote: {Math.round(successRate)}%</span>
                     <span className="ms-2">inkl. Bestand Erfolgsquote: {Math.round(successRateZukunft)}%</span>
                  </p>
                  <p>
                     <span className="me-2">
                        {averageString} Kaufpreis {formatCurrency(totalkaufpreis / counter)}
                     </span>
                     <span className="me-2">
                        {averageString} Provision {formatCurrency(totalProvision / counter)}
                     </span>
                     <span className="me-2">Provision {formatCurrency(totalProvision)}</span>
                  </p>
                  {errorObjekt.length > 0 && (
                     <p style={{ backgroundColor: "#c00", color: "#fff" }}>
                        {" "}
                        Kaufpreis oder Provisionsfehler bei: {errorObjekt.join(", ")}
                     </p>
                  )}

                  <div>
                     <div style={{ display: "flex", flexDirection: "row" }}>
                        {Object.keys(payload[0].payload.data).map((item) => (
                           <div className={"mx-1 "} key={"key_" + item}>
                              {config.stats.vk.stufen[item]}
                              <div className={payload[0].payload.data[item].length > 7 ? "graph-tooltip" : ""}>
                                 <ul>
                                    {payload[0].payload.data[item].map((item2) => (
                                       <li>{item2.elements.objektnr_extern}</li>
                                    ))}
                                 </ul>
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
               </div>
            )}
         </div>
      );
   }

   function CustomLegend({ payload }) {
      return (
         <>
            <ul className="flex-row">
               {payload.map((entry, index) => {
                  return (
                     <li
                        style={{
                           fontWeight: 700,
                           border: "solid 6px " + entry.color,
                           borderRadius: "0px",
                           padding: "2px 10px",
                           margin: "0 10px",
                           listStyle: "none",
                        }}
                        key={`item-${index}`}
                     >
                        {entry.value}
                        {totalData[entry.dataKey] && <span>: {totalData[entry.dataKey].length}</span>}
                     </li>
                  );
               })}
            </ul>
         </>
      );
   }
   return (
      <div className="projektstatus-l2 projektstatus-statistik">
         <div
            style={{
               width: "100%",
               height: "400px",
               position: "relative",
            }}
         >
            <div
               style={{
                  position: "absolute",

                  width: "100%",
                  zIndex: 1000,
               }}
            >
               <h2 style={{ backgroundColor: "#0004", margin: 0, paddingTop: "8px" }}>
                  {year} beauftragte Objekte pro Betreuer und Status
               </h2>
               {graphData && (
                  <ResponsiveContainer
                     style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                     width={"100%"}
                     height={340}
                  >
                     <BarChart
                        data={graphData}
                        margin={{
                           top: 30,
                           right: 0,
                           left: 0,
                           bottom: 5,
                        }}
                        onClick={(e) => {
                           setSelectedUser(e.activePayload[0].payload.userId);
                           console.log(e.activePayload[0].payload.userId);
                        }}
                     >
                        <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "x-small" }} />
                        <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} />
                        <Tooltip
                           cursor={false}
                           isAnimationActive={false}
                           position={{ y: 0, dx: 50 }}
                           content={CustomTooltip}
                        />
                        <Bar
                           stackId="aktiv"
                           dataKey={config.verkaufsStatusFarben.ind_Schl_5021.name}
                           fill={"#ff0c"}
                           // label={renderCustomBarLabel}
                           // label={(e) => renderCustomBarLabel({ ...e, e: e, altLabel: "" })}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e, altLabel: "" })}
                              valueAccessor={(e) => {
                                 return e[config.verkaufsStatusFarben.ind_Schl_5021.name];
                              }}
                           />
                        </Bar>
                        <Bar
                           stackId="aktiv"
                           dataKey={config.verkaufsStatusFarben.ind_Schl_2927.name}
                           fill={"#ff3c"}
                           // label={renderCustomBarLabel}
                           // label={(e) => renderCustomBarLabel({ ...e, e: e, altLabel: "" })}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e, altLabel: "" })}
                              valueAccessor={(e) => {
                                 return e[config.verkaufsStatusFarben.ind_Schl_2927.name];
                              }}
                           />
                        </Bar>
                        <Bar
                           stackId="aktiv"
                           dataKey={config.verkaufsStatusFarben.status2obj_aktiv.name}
                           fill={"#ff6c"}
                           // label={(e) => renderCustomBarLabel({ ...e, e: e, altLabel: "" })}
                           // label={renderCustomBarLabel}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e, altLabel: "" })}
                              valueAccessor={(e) => {
                                 return e[config.verkaufsStatusFarben.status2obj_aktiv.name];
                              }}
                           />
                        </Bar>
                        <Bar
                           stackId="aktiv"
                           dataKey={config.verkaufsStatusFarben.ind_Schl_2929.name}
                           fill={"#ff9c"}
                           label={(e) => renderCustomBarLabel({ ...e, e: e, sumLabel: true, altLabel: "" })}
                           // label={renderCustomBarLabel}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e })}
                              valueAccessor={(e) => {
                                 return e[config.verkaufsStatusFarben.ind_Schl_2929.name];
                              }}
                           />
                        </Bar>
                        <Bar
                           stackId="verloren"
                           dataKey={config.verkaufsStatusFarben.auftrag_entzogen.name}
                           fill={"#f56"}
                           label={(e) => renderCustomBarLabel({ ...e })}
                           // label={renderCustomBarLabel}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e })}
                              valueAccessor={(e) => {
                                 return e[config.verkaufsStatusFarben.auftrag_entzogen.name];
                              }}
                           />
                        </Bar>
                        <Bar
                           stackId="verloren"
                           dataKey={config.verkaufsStatusFarben.fremd_verkauft_vermietet.name}
                           fill={"#f65"}
                           label={(e) => renderCustomBarLabel({ ...e, e: e, sumLabel: true, altLabel: "" })}
                           // label={renderCustomBarLabel}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e })}
                              valueAccessor={(e) => {
                                 return e[config.verkaufsStatusFarben.fremd_verkauft_vermietet.name];
                              }}
                           />
                        </Bar>
                        <Bar
                           stackId="verkauft"
                           dataKey={config.verkaufsStatusFarben.verkauft.name}
                           fill={"#0f0"}
                           label={(e) => {
                              let userGraphData = graphData.find((item) => item.name === e.name);
                              // console.log(userGraphData);

                              // console.log(currentPayload);
                              let verloren = userGraphData["Auftrag entzogen"] + userGraphData["Fremd verkauft"];
                              let verkauft =
                                 userGraphData["Verkauft"] +
                                 userGraphData["In Abwicklung"] +
                                 userGraphData["Aktiv im Verkauf"] +
                                 userGraphData["In Vorlauf (online)"] +
                                 userGraphData["In Vorlauf (offline)"];

                              let successRate = Math.round((100 * verkauft) / (verloren + verkauft));

                              return renderCustomBarLabel({
                                 ...e,
                                 e: e,
                                 sumLabel: true,
                                 altLabel: `(${successRate}%)`,
                              });
                           }}
                           // label={renderCustomBarLabel}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e })}
                              valueAccessor={(e) => {
                                 return e[config.verkaufsStatusFarben.verkauft.name];
                              }}
                           />
                        </Bar>
                        {/* <Bar
                           stackId="verkauft2"
                           dataKey={"Alle Verkauft"}
                           fill={"#0f06"}
                           label={(e) => renderCustomBarLabel({ ...e, e: e, sumLabel: true, altLabel: "" })}
                           // label={renderCustomBarLabel}
                           onClick={(e) => {
                              const { payload } = e;
                              console.log(payload);
                           }}
                        >
                           <LabelList
                              content={(e) => renderCustomBarLabel({ ...e, e: e })}
                              valueAccessor={(e) => {
                                 return e["Alle Verkauft"];
                              }}
                           />
                        </Bar> */}

                        <Legend content={CustomLegend} /* content={(e) => CustomLegend({ ...e, abc: "abc" })}  */ />
                     </BarChart>
                  </ResponsiveContainer>
               )}
            </div>
         </div>
      </div>
   );
}
